import { render, staticRenderFns } from "./ConfirmReservation.vue?vue&type=template&id=203a4869&scoped=true"
import script from "./ConfirmReservation.vue?vue&type=script&lang=js"
export * from "./ConfirmReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a4869",
  null
  
)

export default component.exports